<div class="form-group">
  <label for="" class="text-form">Colaboradores asociados</label>
  <div class="row">
    <div class="col-md-8">
      <div class="input-group">
        <input class="form-control style-input"
          name="name"
          [(ngModel)]="searchText"
          (input)="searchThis()"
          />
        <span class="input-group-addon style-icon-search">
          <i class="fas fa-search fa-lg" aria-hidden="true"></i>
        </span>
      </div>
    </div>
    @if (isCheckbox) {
      <div class="col-md-4 style-checkbox-select">
        <label class="text-form">Select all</label>
        <input class="form-check-input ml-2"  type="checkbox" [(ngModel)]="masterSelected1" name="list_name_1" value="m2" (change)="checkUncheckAll1()">
      </div>
    }
  </div>
</div>
<div class="form-group">
  <table class="table-borderless" style="table-layout: fixed; width: 100%;">
    <colgroup>
    <col span="1" style="width: 40%;">
    <col span="1" style="width: 40%;">
    <col span="1" style="width: 20%;">
  </colgroup>
  <tbody>
    @for (cobAsociat of collaboratorAssociates | filter : searchText; track cobAsociat) {
      <tr>
        <td class="text-table">{{cobAsociat.name}}</td>
        <td class="text-table" style="text-align: center;">{{cobAsociat.profile}}</td>
        <td class="group-checkbox">
          <input class="position-static" type="checkbox" [(ngModel)]="cobAsociat.isSelected" name="list_name_1" value="{{cobAsociat.id}}" (change)="isAllSelected1()" >
        </td>
      </tr>
    }
  </tbody>
</table>
</div>
